import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import ConditionalRender from '@/Atoms/ConditionalRender';
import CCColors from '@/Utils/CCColors';
import React from 'react';
import {Pressable, Image, StyleSheet} from 'react-native';
import {RFPercentage} from 'react-native-responsive-fontsize';
import MenuItems from '../MenuItems';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import logo from '@/Assets/Images/Svgs/home_page/logo.svg';
import {MaterialCommunityIcons} from '@expo/vector-icons';

function CCHomeHeader() {
  return (
    <Box
      gap={'15%'}
      style={styles.wrapper}
      overflow="visible"
      marginTop={20}
      flexDirection="row"
      justifyContent={'flex-start'}
      alignItems="center">
      <Image
        resizeMethod="resize"
        source={logo}
        alt="logo"
        style={styles.image}
      />

      <Box>
        <Box flexDirection="row" gap={28} style={styles.container}>
          <Pressable
            onPress={() => {
              window.open('https://circlechess.com/', '_blank');
            }}>
            {/* RFPercentage */}
            <CCText fontSize={RFPercentage(1.2)} fontWeight="medium">
              Home
            </CCText>
          </Pressable>
          <Pressable
            onPress={() => {
              window.open(
                'https://circlechess.com/caissa-school-of-chess/',
                '_blank',
              );
            }}>
            {/* RFPercentage */}
            <CCText fontSize={RFPercentage(1.2)} fontWeight="medium">
              Caissa School of Chess
            </CCText>
          </Pressable>
          <Pressable
            onPress={() => {
              window.open('https://learn.circlechess.com/', '_blank');
            }}>
            {/* RFPercentage */}
            <CCText fontSize={RFPercentage(1.2)} fontWeight="medium">
              Caissa App
            </CCText>
          </Pressable>
        </Box>
      </Box>
    </Box>
  );
}
const styles = StyleSheet.create({
  wrapper: {width: '100%', paddingLeft: '5%'},
  image: {
    width: 162,
    height: 32,
  },
  container: {
    backgroundColor: CCColors.Primary.lightBrown,
    borderRadius: 24,
    paddingHorizontal: 40,
    paddingVertical: 12,
  },
});
export default CCHomeHeader;
